import {
  type FieldValues,
  type FieldErrors,
  type FieldPath,
  type UseFormRegisterReturn,
} from 'react-hook-form';

type MyInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  name: TName;
  label: string;
  className?: string;
  options: any[];
  optionMethod: (options: any[]) => any[];
  register: UseFormRegisterReturn<string>;
  errors: FieldErrors<TFieldValues>;
  disabled?: boolean;
};

export const RHFSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  label,
  options,
  optionMethod,
  className = '',
  register,
  errors,
  disabled,
}: MyInputProps<TFieldValues, TName>) => {
  const errorMessage =
    typeof errors[name]?.message === 'string' ? errors[name].message : '';
  return (
    <div className='mb-2 py-2'>
      <label
        htmlFor={name}
        className='flex justify-between text-xs font-bold uppercase'
      >
        {label}
      </label>

      <select
        {...register}
        disabled={disabled}
        name={name}
        id={name}
        className={`${className} g-gray-50 mt-1 block w-full  rounded-lg border border-gray-500 p-2.5
                   text-gray-900 focus:border-blue-500 focus:ring-blue-500
                   dark:border-0 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-gray-400
                     ${errorMessage ? 'border-rose-600 dark:border-rose-400' : ''}`}
      >
        <option value=''>{label}</option>
        {optionMethod && optionMethod(options)}
      </select>

      {errorMessage && (
        <span className='text-xs text-rose-600 dark:text-rose-400'>
          {errorMessage}
        </span>
      )}
    </div>
  );
};
